import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { resetAuthUser } from "Slices/Login/loginSlice";
import { storageService } from "Services/storage_service";
import { useNotificationTimer } from "./useNotificationTimer";

export const useLogout = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { clearNotificationTimer } = useNotificationTimer();

  const logout = () => {
    clearNotificationTimer();
    sessionStorage.clear();
    storageService.removeItem("activarRenap");
    storageService.removeItem("contacto");
    storageService.removeItem("diasReporteria");
    storageService.removeItem("footer");
    storageService.removeItem("logoutTime");
    storageService.removeItem("urlFiles");
    storageService.removeItem("refreshToken");
    storageService.removeItem("user");
    dispatch(resetAuthUser());

    if (searchParams.has("dpi")) {
      searchParams.delete("dpi");
      setSearchParams(searchParams);
    }
  };

  return { logout };
};
